import { cn } from '@/lib/utils'

type SpinnerProps = {
  /** 一辺のサイズ（px） */
  size?: number
  /** 線の太さ。未指定ならサイズに応じて自動調整 */
  strokeWidth?: number
  className?: string
}

/**
 * 円形のローディングスピナー。
 *
 * currentColor を使うため、親の text-* で色を変えられる。
 */
export const Spinner = ({ size = 24, strokeWidth, className }: SpinnerProps) => {
  // viewBox は 24 固定なので、実サイズが大きいほど線を細く見せる
  const width = strokeWidth ?? Math.max(1.5, Math.min(3, 72 / size))

  return (
    <svg
      role="status"
      aria-label="読み込み中"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={cn('animate-spin', className)}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth={width} className="opacity-20" />
      <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth={width} strokeLinecap="round" />
    </svg>
  )
}
